import axios from "axios";
import { IDocument } from "../interfaces";
import { config } from "../Map/config";

export interface IRelatedDoc {
    fileName: string;
    storedFileName: string;
    title?: string;
    description?: string;
}

const relatedDocsCache: Record<number, IRelatedDoc[]> = {};
const promises: Record<number, Promise<IRelatedDoc[]>> = {};

export const getRelatedDocsUrls = async (objectId: number): Promise<IDocument[]> => {
    const respData = relatedDocsCache[objectId] || (await getRelatedDocs(objectId));
    if (!respData || !respData.length) {
        return [];
    }
    return respData.map((item: IRelatedDoc) => {
        return {
            fileName: item.fileName,
            title: item.title,
            url: config.dataView.docsApi + "/api/Get?file=" + item.storedFileName,
            description: item.description
        } as IDocument;
    });
};

const getRelatedDocs = (objectId: number): Promise<IRelatedDoc[]> => {
    if (!promises[objectId]) {
        promises[objectId] = axios
            .get(config.dataView.docsApi + "/api/GetRelatedFiles", {
                params: {
                    RelatedObjectId: objectId,
                    Layer: "PUBSDE.LandPlotCatalog"
                }
            })
            .then((resp) => {
                relatedDocsCache[objectId] = resp.data;
                return resp.data;
            })
            .catch((error) => {
                console.log("no related docs for " + objectId + " " + error);
                return [];
            });
    }

    return promises[objectId];
};
